export const center_app_version = {"commit_sha": "a3c3d099"}
